module.exports = __webpack_public_path__ + "static/media/baseline-arrow_drop_down-24px.ebe1c3a6.svg";